import { ENVS, getEnv } from 'config';
import { useAppSelector } from 'app/store';
import { getChatService } from 'app/store/Chat/selectors';
import { getPlaylistService } from 'app/store/Playlists/selectors';
import { getStorageService } from 'app/store/Storage/selectors';
import { showLabelV2Release } from 'app/store/Releases/selectors';

export const features = {
  storage: {
    [ENVS.TEST.NAME]: true,
    [ENVS.QA.NAME]: true,
    [ENVS.PROD.NAME]: true,
  },
  playlist: {
    [ENVS.TEST.NAME]: true,
    [ENVS.QA.NAME]: true,
    [ENVS.PROD.NAME]: true,
  },
  chat: {
    [ENVS.TEST.NAME]: true,
    [ENVS.QA.NAME]: true,
    [ENVS.PROD.NAME]: true,
  },
  selectAIModel: {
    [ENVS.TEST.NAME]: true,
    [ENVS.QA.NAME]: false,
    [ENVS.PROD.NAME]: false,
  },
};

export const isFeatureEnabled = (featureName: keyof typeof features) => {
  const feature = features[featureName];

  if (!feature) {
    return false;
  }

  return feature[getEnv().NAME];
};

export const usePlaylistFeatureFlag = () => {
  const canCreatePlaylist = useAppSelector(getPlaylistService);

  return {
    playlistFeatureEnabled:
      Boolean(canCreatePlaylist) && isFeatureEnabled('playlist'),
  };
};

export const useChatFeatureFlag = () => {
  const canCreateChatMessage = useAppSelector(getChatService);

  return {
    chatFeatureEnabled:
      Boolean(canCreateChatMessage) && isFeatureEnabled('chat'),
  };
};

export const useStorageFeatureFlag = () => {
  const canFetchStorage = useAppSelector(getStorageService);

  return {
    storageFeatureEnabled:
      Boolean(canFetchStorage) && isFeatureEnabled('storage'),
  };
};

export const useLabelV2FeatureFlag = () => {
  const enabled = useAppSelector(showLabelV2Release);

  return {
    labelV2ReleaseEnabled: Boolean(enabled),
  };
};
